(function (ws) {
    'use strict';
    ws.models.saveRFQModel = Backbone.Model.extend({
        url: globals.path.api.westcon.rfqCartSaveUrl
    });
})(westcon);
